import React, {useState, useEffect,useRef} from 'react';
import {Form, Input, Button, Checkbox, Switch, message} from 'antd';
import {http, history} from 'libs';

import {observer} from 'mobx-react';
import store from "./store";

import styles from './layout.module.less'

// the hook
import {useTranslation} from 'react-i18next';

const layout = {
  labelCol: {span: 8},
  wrapperCol: {span: 7},
};

const tailLayout = {
  wrapperCol: {offset: 8, span: 7},
};

export default observer(function () {
  const {t} = useTranslation();
  const [userForm] = Form.useForm();

  useEffect(() => {
    store.fetchUserInfo()
  }, [])

  useEffect(()=>{
    userForm.setFieldsValue(store.userInfo);
  },[store.userInfo])

  const onFinish = formData => {
    store.updateUserInfo(formData)
  }

  const onFinishFailed = errorInfo => {
  }

  // let userInfo = {...store.userInfo}
  // console.log(userInfo,'userInfo');
  return (
    <React.Fragment>
      <div className={[styles.cart, 'rest-nav1'].join(" ")}>

        <div className={styles.listTitle}>
          <span className={styles.title}>{t('个人信息')}</span>
        </div>
        <div className="mainBox">


          <Form
            {...layout}
            name="basic"
            form={userForm}
            className={styles.form}
            // initialValues={userInfo}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Form.Item
              label={t('姓名')}
              name="name"
              rules={[{required: true, message: t('请输入')+'!'}]}
            >
              <Input disabled={true}/>
            </Form.Item>

            <Form.Item
              label={t('职务')}
              name="approveRole"
            >
              <Input disabled={true}/>
            </Form.Item>

            <Form.Item
              label={t('单位')}
              name="organization_str"
              rules={[{required: true, message: t('请输入')+'!'}]}
            >
              <Input disabled={true}/>
            </Form.Item>

            <Form.Item
              label={t('手机号码')}
              name="phone"
              rules={[{required: true, message: t('请输入')+'!'}]}
            >
              <Input disabled={true}/>
            </Form.Item>

            <Form.Item
              label={t('电子邮箱')}
              name="email"
              rules={[{required: true, message: t('请输入')+'!'}]}
            >
              <Input disabled={true}/>
            </Form.Item>

            <Form.Item
              hidden={true}
              label="求购处理通知"
              name="mail_preorder"
              valuePropName="checked"
              rules={[{required: true, message: '请输入!'}]}
            >
              <Switch/>
            </Form.Item>

            <Form.Item
              hidden={true}
              label="审批处理通知"
              name="mail_approve"
              valuePropName="checked"
              rules={[{required: true, message: '请输入!'}]}
            >
              <Switch/>
            </Form.Item>

            <Form.Item
              hidden={true}
              label="审批任务通知"
              name="mail_new_approve"
              valuePropName="checked"
              rules={[{required: true, message: '请输入!'}]}
            >
              <Switch/>
            </Form.Item>

            <Form.Item
              hidden={true}
              label="订单逾期通知"
              name="mail_devilery"
              valuePropName="checked"
              rules={[{required: true, message: '请输入!'}]}
            >
              <Switch/>
            </Form.Item>


            {/* <Form.Item {...tailLayout}>
              <Button className={styles.btn} type="primary" htmlType="submit" size='large'
                      loading={store.isFetching}>{t('保存')}</Button>
            </Form.Item> */}
          </Form>


        </div>

      </div>
    </React.Fragment>
  )
})
